import { Capacitor } from "@capacitor/core";
import { LocalNotifications } from "@capacitor/local-notifications";

export async function requestLocalNotificationPermission() {
  if (!Capacitor.isNativePlatform()) {
    return { display: "denied" as const };
  }
  return LocalNotifications.requestPermissions();
}

export async function checkLocalNotificationPermission() {
  if (!Capacitor.isNativePlatform()) {
    return { display: "denied" as const };
  }
  return LocalNotifications.checkPermissions();
}

export async function scheduleLocalNotification(options: {
  id: number;
  title: string;
  body: string;
  scheduleAt: Date;
}) {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  return LocalNotifications.schedule({
    notifications: [
      {
        id: options.id,
        title: options.title,
        body: options.body,
        schedule: { at: options.scheduleAt },
        actionTypeId: "",
        extra: null,
      },
    ],
  });
}

export async function cancelLocalNotifications(ids: number[]) {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  return LocalNotifications.cancel({
    notifications: ids.map((id) => ({ id })),
  });
}

export async function getPendingLocalNotifications() {
  if (!Capacitor.isNativePlatform()) {
    return { notifications: [] };
  }
  return LocalNotifications.getPending();
}
